import { useMutation } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'
import { createWorkspace } from '@/features/workspaces/api/create-workspace'
import { useReloadMyOrganizations } from '@/features/workspaces/composables/useReloadMyOrganizations'
import type { ApiError } from '@/lib/api/errors'
import { useWorkspaceStore } from '@/stores/workspace'

export function useCreateWorkspace() {
  const workspaceStore = useWorkspaceStore()
  const reloadMyOrganizations = useReloadMyOrganizations()
  const { t } = useI18n()

  return useMutation({
    mutationFn: createWorkspace,
    onSuccess: async (workspace) => {
      // Reload first so the new workspace (and its permissions) is in the store.
      await reloadMyOrganizations()
      workspaceStore.setCurrentAccount(String(workspace.id))
      toast.success(t('workspaces.toast.created'))
    },
    onError: (error: unknown) => {
      toast.error((error as ApiError).message || t('workspaces.toast.createFailed'))
    },
  })
}
